import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DragItem {
  id: number | string;
  name: string;
  type?: string;
}

// 🧠 Define slice state
interface AuditeeState {
  step1: {
    availableMembers: DragItem[];
    selectedMembers: DragItem[];
  };
  step2: {
    availableThemes: DragItem[];
    selectedThemes: DragItem[];
    sequenceSteps: any[];
  };
}

const initialState: AuditeeState = {
  step1: {
    availableMembers: [],
    selectedMembers: [],
  },
  step2: {
    availableThemes: [],
    selectedThemes: [],
    sequenceSteps: [],
  },
};

const auditeeSlice = createSlice({
  name: "auditee",
  initialState,
  reducers: {
    // --- Step 1 (Members) ---
    setAvailableMembers: (state, action: PayloadAction<DragItem[]>) => {
      state.step1.availableMembers = action.payload;
    },
    setSelectedMembers: (state, action: PayloadAction<DragItem[]>) => {
      state.step1.selectedMembers = action.payload;
    },

    // --- Step 2 (Audit Themes) ---
    setAvailableThemes: (state, action: PayloadAction<DragItem[]>) => {
      state.step2.availableThemes = action.payload;
    },
    setSelectedThemes: (state, action: PayloadAction<DragItem[]>) => {
      state.step2.selectedThemes = action.payload;
    },
    setSequenceSteps: (state, action: PayloadAction<any[]>) => {
      state.step2.sequenceSteps = action.payload;
    },

    // Optional reset actions
    resetStep1: (state) => {
      state.step1.availableMembers = [];
      state.step1.selectedMembers = [];
    },
    resetStep2: (state) => {
      state.step2.availableThemes = [];
      state.step2.selectedThemes = [];
      state.step2.sequenceSteps = [];
    },
    resetAll: () => initialState,
  },
});

export const {
  setAvailableMembers,
  setSelectedMembers,
  setAvailableThemes,
  setSelectedThemes,
  setSequenceSteps,
  resetStep1,
  resetStep2,
  resetAll,
} = auditeeSlice.actions;

export default auditeeSlice.reducer;
